import styled, { css } from 'styled-components';
import { setLayoutWidth } from 'styles/sharedStyles';
import { HoverTypes } from './Navigation.types';

const fixTextShakingOnHover = css`
  &:before {
    display: block;
    content: attr(title);
    //font-weight: 500;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

const buildNavbarBorder = css`
  &::after {
    color: transparent;
    background: #219ad6;

    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;

    /* DOCS: */
    /* https://stackoverflow.com/questions/22532883/animate-length-of-border-bottom */
    content: '';
    position: absolute;
    width: 100%;
    height: 0px;
    border-bottom: 2px solid #219ad6;
    bottom: -1px;
    opacity: 0;
    transform: scaleX(0.2);
    transition: transform 0.2s ease-in, opacity 0.2s ease-in;
  }
`;

export const Navbar = styled.div<HoverTypes>`
  width: 100%;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  display: flex;
  gap: 2.5%;

  &::before {
    content: '';
    height: 0;
    width: 100%;
    position: absolute;
    left: 0;
    top: 100%;
    opacity: 0;

    transform: translateY(1px);
    background-color: white;

    transition: opacity 0.3s, height 0.2s;
  }

  &:hover {
    &::before {
      height: ${props =>
        props.isThereSubmenu
          ? `${props.dynamicSubmenuBackgroundHeight}px`
          : '0'};
      opacity: ${props => (props.isThereSubmenu ? '1' : '0')};
    }
  }
  /* reason for commenting out: this padding makes submenu background 
  dynamic height function unreliable, but kept it until its reviewed */
  /* > div:not(:first-child) {
    padding-left: 2%;
  }
  > div {
    padding-right: 2%;
  } */
`;

export const NavbarItem = styled.div<HoverTypes>`
  > .parentNav {
    ${buildNavbarBorder};
  }
  & > .subNav {
    transition: all 0.3s;
  }

  &:hover {
    > .subNav {
      opacity: ${props => (props.isThereSubmenu ? '1' : '0')};
      visibility: visible;
    }
    > .parentNav {
      color: rgba(0, 0, 0, 0.94) !important;
      font-weight: 500;

      &::after {
        opacity: 1;
        transform: scaleX(1);
      }
    }
  }
  ${({ theme }) => theme.breakpoints.down('xl')} {
    font-size: 0.95rem;
  }
`;

export const ParentCategoryItem = styled.div`
  display: inline-block;
  padding: 20px 0;
  cursor: pointer;
  position: relative;
  text-align: center;

  &:hover,
  &.hovered {
    color: rgba(0, 0, 0, 0.94) !important;
    font-weight: 500;
    border-bottom: 2px solid #219ad6;
  }

  &.active {
    font-weight: 500;
    border-bottom: 4px solid #219ad6;
    color: rgba(0, 0, 0, 0.94);
  }

  ${fixTextShakingOnHover};
`;

export const SubCategoryContainer = styled.div<{ isHovered: boolean }>`
  overflow: hidden;
  visibility: ${({ isHovered }) => (isHovered ? 'visible' : 'hidden')};
  opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
  width: 100%;
  position: absolute;
  left: 0;
  top: calc(100% + 1px);
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const SubCategoryList = styled.div`
  ${setLayoutWidth};
  margin: 10px auto;
  height: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, minmax(0, 1fr));
  grid-auto-flow: column;
  gap: 5px;
`;
export const SubCategoryListItem = styled.a`
  margin: 5px 0px;
  cursor: pointer;

  text-decoration: none;
  color: inherit;

  &:hover {
    color: rgba(0, 0, 0, 0.94) !important;
    font-weight: 500;
  }
`;

export const NewItem = styled.div`
  position: absolute;
  right: -25px;
  top: 5px;
  background: #388e3c;
  border-radius: 10px;
  font-size: 0.55rem;
  color: white;
  padding: 2px 5px;
  opacity: 1;
`;
